export default __webpack_public_path__ + "static/media/home.64e1c85f.svg";